import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/largeLogo.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "error_content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "error_logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "error_title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "403"),
  /*#__PURE__*/_createElementVNode("h3", null, "접근이 거부되었습니다.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "error_text" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "요청하신 페이지 접근이 거부되었습니다."),
    /*#__PURE__*/_createElementVNode("p", null, "입력하신 페이지의 주소가 정확한지 다시 한번 확인해주시기 바랍니다.")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", null, "뒤로 가기", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", {
          class: "error_btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
        }, _hoisted_8)
      ])
    ])
  ]))
}